import { useParams } from 'react-router-dom'
import { UnifiedAgentProvider } from 'pages/chatbot/ui/UnifiedAgent'
import { ChatbotEditV2Page } from 'pages/chatbot/pages/chatbotEdit/ui/ChatbotEditV2Page'

export const ChatbotEditV2Layout = () => {
  const { agentId } = useParams()

  return (
    <UnifiedAgentProvider agentId={agentId ? +agentId : null}>
      <ChatbotEditV2Page />
    </UnifiedAgentProvider>
  )
}
